import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import './Button.css'

class Button extends Component {


    render() {

        const { style, to, className, external, tabIndex } = this.props

        const theme = className || "btn"

        const internalBtn = <Link to={to} className={theme} style={style} tabIndex={tabIndex}>
            {this.props.children}
        </Link>
        
        const externalBtn = <a target="_blank" rel="noopener noreferrer" href={to} className={theme} style={style} tabIndex={tabIndex}>
            {this.props.children}
        </a>

        const btn = external ? externalBtn : internalBtn

        return (
            btn
        );
    }
}


export default Button;